/** The high-score tables' columns (docs/spec/04 §6): rank, score, initials, stage reached. Pure. */

import type { ScoreEntry, TableId } from '../../game/hiscores';
import { commas, ordinal } from '../kit/text';

export const TABLE_TABS: readonly { readonly id: TableId; readonly label: string }[] = [
  { id: 'supernova', label: 'SUPERNOVA' },
  { id: 'classic', label: 'CLASSIC' },
];

/**
 * Screen columns: a marker in column 1, the rank right-aligned in 2-5, the score in 7-15, the
 * initials in 17-19 and the stage in 22-26. Right edges are the column after, in characters.
 */
export const SCORE_COLS = { marker: 1, rankEnd: 6, scoreEnd: 16, initials: 17, stageEnd: 27 } as const;

export interface ScoreLine {
  readonly rank: string;
  readonly score: string;
  readonly initials: string;
  readonly stage: string;
}

/** Line `i` (0-based) of a table as its four columns. */
export function scoreLine(i: number, e: ScoreEntry): ScoreLine {
  const withCommas = commas(e.score);
  return {
    rank: ordinal(i + 1),
    // Nine columns: a score too long for its commas goes without them.
    score: withCommas.length > 9 ? String(Math.floor(e.score)).slice(-9) : withCommas,
    initials: (e.initials + '   ').slice(0, 3),
    stage: String(Math.max(1, Math.floor(e.stage))).slice(-5),
  };
}

/** A line as it sits across columns 1-26, 26 characters (the screen draws it column by column). */
export function lineText(l: ScoreLine): string {
  return ` ${l.rank.padStart(4)} ${l.score.padStart(9)} ${l.initials}  ${l.stage.padStart(5)}`;
}

export const HEADINGS: ScoreLine = { rank: 'RANK', score: 'SCORE', initials: 'NAME', stage: 'STAGE' };

/** What to say under the table when a new score is on it. */
export function placeLine(rank: number): string {
  return `YOUR SCORE TOOK ${ordinal(rank + 1)} PLACE`;
}

/** The tab for `table` (the first when it is not given). */
export function tabOf(table: TableId | undefined): number {
  return Math.max(0, TABLE_TABS.findIndex((t) => t.id === table));
}
